import { apiFetch, type PaginatedResponse } from './api';

export interface AuditLog {
  id: string;
  timestamp: string;
  userId: string;
  userName: string;
  userEmail?: string;
  action: string;
  category: 'auth' | 'user' | 'project' | 'container' | 'release' | 'pack' | 'ptero' | 'procedure' | 'cdn' | 'promotion' | string;
  targetId?: string;
  targetLabel?: string;
  projectId?: string;
  status: 'ok' | 'ko' | string;
  details?: Record<string, unknown>;
}

export interface AuditQuery {
  projectId?: string;
  category?: string;
  userId?: string;
  action?: string;
  search?: string;
  page?: number;
  pageSize?: number;
}

export const auditService = {
  list: (q: AuditQuery = {}) => {
    const params = new URLSearchParams();
    if (q.projectId) params.set('projectId', q.projectId);
    if (q.category) params.set('category', q.category);
    if (q.userId) params.set('userId', q.userId);
    if (q.action) params.set('action', q.action);
    if (q.search) params.set('search', q.search);
    params.set('page', String(q.page ?? 0));
    params.set('pageSize', String(q.pageSize ?? 50));
    return apiFetch<PaginatedResponse<AuditLog>>(`/api/audit?${params.toString()}`);
  },
};
